import { call, put, takeEvery, all, select } from 'redux-saga/effects';
import * as actions from '../../Actions/analytics';
import { matchesType } from '../sagas';

async function loadTrackingScript() {
  window.analytics.load(process.env.REACT_APP_SegmentIoKey || '');

  return new Promise((resolve, reject) => {
    const readyInterval = setInterval(() => {
      try {
        if (window.analytics) {
          clearInterval(readyInterval);
          resolve();
        }
      } catch (error) {
        clearInterval(readyInterval);
        reject(error);
      }
    });
  });
}

function* loadAnalytics() {
  try {
    yield call(loadTrackingScript);
    yield put(actions.analyticsLoaded());
  } catch (err) {
    console.log(err);
  }
}

function* track(action: ReturnType<typeof actions.track>) {
  if (window.analytics) {
    const { source, tierName } = yield select((state) => state.App);
    const payload = {
      source,
      tierName,
      integration: source,
      ...action.payload.eventData
    };
    return window.analytics.track(action.payload.eventName, payload);
  }
}

function* trackAndNavigate(action: ReturnType<typeof actions.trackAndNavigate>) {
  if (window.analytics) {
    const { source, tierName } = yield select((state) => state.App);
    const payload = {
      source,
      tierName,
      integration: source,
      ...action.payload.eventData
    };
    yield track(actions.track(action.payload.eventName, payload));
    window.location.assign(action.payload.url);
  }
}

function pageView(action: ReturnType<typeof actions.pageView>) {
  if (window.analytics) {
    return window.analytics.page(action.payload.path, action.payload.eventData);
  }
}

function* analytics() {
  yield all([
    takeEvery(matchesType(actions.loadAnalytics), loadAnalytics),
    takeEvery(matchesType(actions.track), track),
    takeEvery(matchesType(actions.trackAndNavigate), trackAndNavigate),
    takeEvery(matchesType(actions.pageView), pageView),
  ]);
}

export { analytics };



// WEBPACK FOOTER //
// ./src/redux/sagas/analytics.ts